var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlShopCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "33.9801827px",
    viewBox: "0 0 35 33.9801827",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5C5D798C-362D-43DA-8A9D-C21FEC6EB86C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PI2-2023-Setpay-Rebrand-&-soft-apply",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MPP-Revolve-Pay4-Pay-Later-Soft-Apply-Copy",
    transform: "translate(-36, -846)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PayLater-Expanded-promo",
    transform: "translate(20, 593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PL-ShopCart",
    transform: "translate(16, 253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7368743,10.6646224 C34.5477014,10.4990961 34.3112352,10.380863 34.0747691,10.380863 C34.0747691,10.380863 34.0747691,10.380863 34.0747691,10.380863 L12.2962387,10.4518029 L7.47232966,1.08774419 C7.14127708,0.425639031 6.4318787,0 5.67518708,0 L0,0 L0,1.89172903 L5.67518708,1.89172903 C5.72248031,1.89172903 5.76977354,1.91537564 5.79342015,1.96266887 L16.5762756,23.0081543 C16.7418019,23.3155603 17.0728545,23.5283798 17.4275537,23.5283798 L34.0511225,23.5283798 C34.571348,23.5283798 34.996987,23.1027408 34.996987,22.5825153 L34.996987,11.3267276 C35.0206336,11.0666148 34.9024006,10.8301487 34.7368743,10.6646224 Z M33.1289046,21.6366508 L17.9950724,21.6366508 L13.2421032,12.3435319 L33.105258,12.2725921 L33.105258,21.6366508 L33.1289046,21.6366508 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4885314,25.7038682 C13.19481,25.7038682 11.3503742,27.5719506 11.3503742,29.8420254 C11.3503742,32.1357469 13.2184566,33.9801827 15.4885314,33.9801827 C17.7822529,33.9801827 19.6266887,32.1121003 19.6266887,29.8420254 C19.6266887,27.548304 17.7586063,25.7038682 15.4885314,25.7038682 Z M15.4885314,32.0884536 C14.2352609,32.0884536 13.2421032,31.0716493 13.2421032,29.8420254 C13.2421032,28.5887549 14.2589075,27.5955972 15.4885314,27.5955972 C16.7418019,27.5955972 17.7349596,28.6124015 17.7349596,29.8420254 C17.7349596,31.0952959 16.7181553,32.0884536 15.4885314,32.0884536 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7947322,25.7038682 C27.5010107,25.7038682 25.6565749,27.5719506 25.6565749,29.8420254 C25.6565749,32.1357469 27.5246574,33.9801827 29.7947322,33.9801827 C32.064807,33.9801827 33.9328894,32.1121003 33.9328894,29.8420254 C33.9328894,27.548304 32.0884536,25.7038682 29.7947322,25.7038682 Z M29.7947322,32.0884536 C28.5414617,32.0884536 27.548304,31.0716493 27.548304,29.8420254 C27.548304,28.5887549 28.5651083,27.5955972 29.7947322,27.5955972 C31.0243561,27.5955972 32.0411604,28.6124015 32.0411604,29.8420254 C32.0411604,31.0952959 31.0243561,32.0884536 29.7947322,32.0884536 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlShopCart);
export default __webpack_public_path__ + "static/media/PL-ShopCart.b0bcd6042c4819359efa44dc614d4818.svg";
export { ForwardRef as ReactComponent };